module.exports = __webpack_public_path__ + "img/zanorari24.1da8717a.jpg";